import React, { useState } from 'react';
import { required, downloadCSV, ReferenceField, ReferenceArrayInput, AutocompleteArrayInput, useMutation, useNotify, 
    Button, NumberField, ArrayField, Toolbar, SaveButton, NumberInput, TabbedForm, FormTab, FormDataConsumer, 
    SelectArrayInput, ArrayInput, SimpleFormIterator, Edit, Create, BooleanInput, List, Datagrid, useRefresh, 
    DateField, TextField, TextInput, AutocompleteInput, ReferenceInput, SelectInput, BooleanField, UrlField, 
    FunctionField, TopToolbar, FilterButton, CreateButton, ExportButton, sanitizeListRestProps, useListContext,
    fetchUtils, Confirm } from 'react-admin';

import { ExpandMore } from '@material-ui/icons';
import Link from '@material-ui/core/Link';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import SyncIcon from '@material-ui/icons/Sync';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import LinkIcon from '@material-ui/icons/Link';
import { Accordion, AccordionSummary, AccordionDetails, Box, Card } from '@material-ui/core';
import dataProvider from './dataprovider'
import { useForm, useFormState } from 'react-final-form';
import jsonExport from 'jsonexport/dist';
import InactiveIcon from '@material-ui/icons/Warning';
import { CustomDateField } from './components/utils';
import { SiteTabs } from './components/siteTabs';
const fetch = fetchUtils.fetchJson;
const mediaCategories = require('./components/media_categories.json');
const specialCategories = require('./components/special_categories.json');
const utils = require('./components/utils');
const { InactiveButtonStyle } = require('./styles/common')
const {EXCLUDED_BIDDERS_LIST, AdstxtListStatus, CrawlButton, MissingAdstxtButton, BidderStatus, AdstxtIPWhiteList} = require('./components/adstxt_status');
const {AUDIT_STATUS, AuditStatusDetail, AuditListStatus, AuditStatus, RejectedButton, BlockedButton} = require('./components/audit_status');

const AD_SIZES = [[970, 250], [300, 100], [300, 600], [970, 90], [300, 50], [300, 250], [728, 90], [336, 280], [160, 600], [970, 66], [320, 50], [320, 100], [300, 1050], [120, 600], [480, 60], [250, 250], [468, 60], [200, 200], [375, 350], [320, 480], [300, 168], [300, 75], [120, 20], [120, 30], [216, 54], [234, 60], [216, 36], [168, 28], [120, 90], [120, 60], [88, 31], [900, 90], [180, 150], [320, 250], [120, 240], [125, 125], [580, 400], [150, 125], [1350, 17], [480, 320], [200, 150]];

const SCREEN_SIZES_WIDTH_RANGE = [
    {name: 'Mobile', maxSize: 767, id: '[0,0]'},
    {name: 'Tablet', maxSize: 992, id: '[767,0]'},
    {name: 'Desktop', maxSize: 2000, id: '[992,0]'}
];

let globalRole = 'publisher';
const ReactHighcharts = require('react-highcharts');

const choicesAdType = [
    { "id": "banner", "name": "BANNER" },
    { "id": "video",  "name": "VIDEO" }
];
const dateRangeChoices = [
    { id: 1, name: 'Yesterday' },
    { id: 2, name: 'Last 2 Days' },
    { id: 3, name: 'Last 3 Days' },
    { id: 5, name: 'Last 5 Days' },
    { id: 7, name: 'Last 7 Days' },
    { id: 8, name: 'Last 8 Days' },
    { id: 10, name: 'Last 10 Days' },
    { id: 15, name: 'Last 15 Days' },
    { id: 30, name: 'Last 30 Days' },
    { id: 'lm', name: 'Last Month' },
    { id: 'mtd', name: 'Month to Date' },
    { id: 'mty', name: 'Month to Yesterday' }
];
const AnalyzeSiteButton = (props, parent) => {
    let [disabled, setDisabled] = useState(false);
    let [label, setLabel] = useState('Analyze Site');
    let [dateRange, setDateRange] = useState('lm');
    let [adType, setAdType] = useState();
    const analyze = () => {
        function totalDataLoaded (parent, data) {
            setDisabled(false);
            setLabel('Analyze Site');
            if (data && record && record.domain && record.domain.adstxt_results && record.domain.adstxt_results.bidder_results) {
                for (const bidder of record.domain.adstxt_results.bidder_results) {
                    bidder.total_response_rate = '-';
                    for (const report of data) {
                        if (report.bidder_id == bidder.bidder_id) {
                            bidder.total_response_rate = utils.double(report.response_rate, '%');
                            break;
                        }
                    }
                }
                parent.forceUpdate();
            }
        }
        function siteDataLoaded (parent, data) {
            setDisabled(false);
            setLabel('Analyze Site');
            if (data && record && record.domain && record.domain.adstxt_results && record.domain.adstxt_results.bidder_results) {
                for (const bidder of record.domain.adstxt_results.bidder_results) {
                    bidder.net_revenue = '-';
                    bidder.revenue = '-';
                    bidder.impressions = '-';
                    bidder.bid_requests = '-';
                    bidder.bid_responses = '-';
                    bidder.response_rate = '-';
                    bidder.rpm_bid_requests = '-';
                    bidder.win_rate = '-';
                    bidder.tech_cost = '-';
                    bidder.net_profit = '-';
                    bidder.color = 'white';
                    for (const report of data) {
                        if (report.bidder_id == bidder.bidder_id) {
                            bidder.net_revenue = utils.double(report.net_revenue);
                            bidder.revenue = utils.double(report.revenue);
                            bidder.impressions = utils.long(report.impressions);
                            bidder.bid_requests = utils.long(report.bid_requests);
                            bidder.bid_responses = utils.long(report.bid_responses);
                            bidder.response_rate = utils.double(report.response_rate, '%');
                            bidder.rpm_bid_requests = utils.double(report.rpm_bid_requests);
                            bidder.win_rate = utils.double(report.win_rate, '%');
                            bidder.tech_cost = utils.double(report.tech_cost);
                            bidder.net_profit = utils.double(report.net_profit);
                            bidder.color = report.net_profit < 0 ? 'red' : 'white';
                            break;
                        }
                    }
                }
                parent.forceUpdate();
            }
        }
        const record = props.record;
        setDisabled(true);
        setLabel('Analyzing Site...');
        const options = { headers: new Headers() };
        options.headers.set('accept', 'application/json');
        const token = localStorage.getItem('token');
        options.headers.set('Authorization', `Bearer ${token}`);
        let show = ['bidder', 'bid_requests', 'bid_responses', 'response_rate', 'revenue', 'rpm_bid_requests', 'win_rate', 'tech_cost', 'net_profit'];
        const showUrl = `show=${show.join('&show=')}`;
        const theAdType = adType || '';
        let url = `//reports.nobid.io/console/pubreports_report?${showUrl}&interval=year&date_range=${dateRange}&ad_type=${theAdType}&site_id=${record.code}`;
        fetch(url, options).then(({ headers, json }) => (
            siteDataLoaded(props.parent, json)
        ));
        show = ['bidder', 'response_rate'];
        url = `//reports.nobid.io/console/pubreports_report?${showUrl}&interval=year&date_range=${dateRange}&ad_type=${theAdType}`;
        fetch(url, options).then(({ headers, json }) => (
            totalDataLoaded(props.parent, json)
        ));
    }
    return <div style={{ width: '50%', overflow: 'hidden', display: 'flex', columnGap: '10px' }} id="wrapper2">
            <div style={{flex: 0}}>
            <SelectInput label="Date Range" source="date_range"
                onChange={value => setDateRange(value.target.value)}
                choices={dateRangeChoices}
                defaultValue="lm"
                disabled={disabled} />
            </div>
            <div style={{flex: 0}}>
                <SelectInput label="Ad Type" source="ad_type" 
                onChange={value => setAdType(value.target.value)}
                choices={choicesAdType}
                disabled={disabled}
                style={{width: '120px'}}
                allowEmpty
                />
            </div>
            <div style={{flex: 1}}>
            <Button label={label} onClick={analyze} disabled={disabled} startIcon={<RunReportIcon />} props={props} 
            variant="contained" color="primary" style={{marginTop: '20px'}}/>
            </div>
        </div>;
};

const WrapupScriptDeploy = ({ record, disabledPublish, ...props }) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [confirmationBodyText, setConfirmationBodyText] = useState('');
    const {dirty, dirtyFields, values} = useFormState();
    // let state = useFormState();
    const [deploy, { loading }] = useMutation();

    const handleClose = () => setConfirmationOpen(false)
    
    const handleConfirm = () => {
        setConfirmationOpen(false);
        deploy ({
            type: 'getOne',
            resource: 'wrapup?id='+record?.code+'&x=',
            payload: {}
        },
        {
            onSuccess: ({data}) => {
                refresh();
                notify(data.message, {type: 'info'});
            },
            onFailure: (error) => {
                // console.log(error.message)
                notify(`Wrapup deploy error: ${error.message}`, {type: 'warning'})
            }
        });
    }

    const valueGet = (stringPath, obj) => stringPath.split('.').reduce((p, c) => [undefined, []].includes(p?.[c]) ? false : p?.[c], obj);
    let unsaved = dirty && Object.keys(dirtyFields).some(x => x.startsWith('wrapup_config') && valueGet(x, record) !== valueGet(x, values));

    const handleClick = () => {
        if (record?.wrapup_config?.deployedVersions?.find(x => x.url.indexOf(record.wrapup_config.pversion) > -1)) {
            setConfirmationOpen(true);
            setConfirmationBodyText('This version is already deployed. Would you like to overwrite it?');
        } else {
            handleConfirm();
            setConfirmationOpen(false);
        }
    }

    return <>
        <Confirm 
            isOpen={confirmationOpen} 
            title={`Publish version ${record?.wrapup_config?.pversion}`}
            content={confirmationBodyText}
            onConfirm={handleConfirm}
            onClose={handleClose}
        />
        <div style={{display: 'flex', gap: '10px'}}>
            <Button label="Publish Prebid Wrapper" style={{height: '48px', marginTop: '8px'}} onClick={handleClick} disabled={loading || unsaved} variant="contained" color="primary"/>
            <div><TextInput source='wrapup_config.pversion' label='Version' defaultValue='1.0.0' /></div>
            { unsaved && <p style={{paddingTop: '16px', color: 'white', fontSize: 'x-small'}}>Unsaved changes pending!</p> }
            { loading && <p style={{paddingTop: '16px', color: '#e91e63', fontSize: 'x-small'}}>Publishing in progress...</p> }
        </div>
    </>
}

const SyncAppnexusButton = ({ record }) => {
    const notify = useNotify();
    const [crawl, { loading }] = useMutation({
        type: 'getOne',
        resource: 'sync_apn?id='+record.code+'&x=',
        payload: { }
    },
        {
            onSuccess: (data) => {
                console.log("RECEIVED DATA:", data)
                notify('We have setup Appnexus for this Site', 'info', {}, false);
                if (data && data.data) {
                    window.location.reload(false)
                }
            },
            onFailure: (error) => notify(`Site sync Appnexus error: ${error.message}`, 'warning'),
        }
    );
    if (record.bidder_config) {
        let found312 = record.bidder_config.find(elem => { return (elem.bidder_id == 312) })
        let found313 = record.bidder_config.find(elem => { return (elem.bidder_id == 313) })
        if (found312 || found313) {
            return <Button disabled label="Setup Appnexus IDs" startIcon={<SyncIcon />} variant="contained" color="primary" />;
        }
    }
    return <Button label="Setup Appnexus IDs" onClick={crawl} disabled={loading} startIcon={<SyncIcon />} variant="contained" color="primary" />;
};

const config = {
    chart: { zoomType: 'xy' },
    title: { text: 'Network Revenue Report' },
    subtitle: { text: 'Source: Nobid Inc.' },
    yAxis: [{ // Primary yAxis
        labels: { format: '${value}' },
        title: { text: 'Revenue' }
    }, { // Secondary yAxis
        labels: { format: '{value}' },
        title: { text: 'Impressions' },
        opposite: true
    }],
    tooltip: { shared: true },
    legend: {
        layout: 'vertical',
        align: 'left',
        x: 120,
        verticalAlign: 'top',
        y: 100,
        floating: true,
        backgroundColor: 'rgba(255,255,255,0.25)'
    }
};

const validateAdsTxtFormat = fd => {
  const errors = {};
  if (fd.adstxt_domain) {
    if (fd.type && fd.type === 'app' && !fd.adstxt_domain.endsWith('/app-ads.txt')) {
      errors.adstxt_domain = {message: 'Format should be like http://www.site.com/app-ads.txt'};
    } else if (fd.type && fd.type !== 'app' && fd.adstxt_domain.endsWith('/app-ads.txt')) {
      errors.adstxt_domain = {message:'Format should be like http://www.site.com/ads.txt'};
    }
  }
  return errors;
}

class RevenueChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listDataFromChild: null
        };
    }
    render() {
        let impressions = [];
        let revenue = [];
        let dates = [];
        const site = this.props.source;
        if (site && site.revenue_stats && site.revenue_stats.daily) {
            const stats = site.revenue_stats.daily;
            for (let i in stats) {
                impressions.push(stats[i].impressions);
                revenue.push(stats[i].revenue);
                dates.push('' + stats[i].date);
            }
        }
        config.series = [{
            name: 'Impressions',
            type: 'column',
            color: '#f0781d',
            yAxis: 1,
            data: impressions,
            tooltip: { valueSuffix: '' }

        }, {
            name: 'Revenue',
            type: 'spline',
            color: '#0da330',
            data: revenue,
            tooltip: { valuePrefix: '$' }
        }]
        config.xAxis = [{
            type: 'datetime',
            labels: { format: '{value:%Y-%b-%e}' },
            categories: dates,
            crosshair: true
        }]
        return (
            <ReactHighcharts config={config}></ReactHighcharts>
        );
    }
}

const siteFilters = [
    <TextInput label="Search" source="search_name" alwaysOn resettable />,
    <ReferenceArrayInput alwaysOn source="publisher_id" label="Publisher"
        reference="publishers"
        basePath='publishers'
        perPage={10}
        sort={{ field: 'name', order: 'ASC' }}
        filterToQuery={searchText => ({ search_name: searchText })}
    >
        <AutocompleteArrayInput label="Publishers" optionText="name" optionValue="code" style={{ width: '90%' }} />
    </ReferenceArrayInput>,
    <NumberInput label="Site ID" source="search_id" resettable />,
    <SelectArrayInput source="type" choices={utils.SITE_TYPES} label="Type" resettable />,
    <BooleanInput source="wrapup_config.analyticsEnabled" label="Analytics Enabled" defaultValue={true} resettable />,
    <BooleanInput source="wrapup_config.carbonizerEnabled" label="Optimizer Enabled" defaultValue={true} resettable />
];

const exporter = (sites) => {
    function creationDate(site) {
        if (site.created_at) {
            if (site.created_at.indexOf('T')>0) return site.created_at.substring(0, site.created_at.indexOf('T'));
            else return site.created_at;
        }
        return '';
    }
    const sitesForExport = sites.map(site => {
        let o = {
            id: site.code,
            name: site.name,
            publisher_id: site.publisher_id,
            type: site.type || 'site',
            creation_date: creationDate(site),
            active: site.active
        };
        if (globalRole === 'admin') {
            o.adunit_path = site.adunit_path;
            o.prediction_pace = site.prediction_throttle_pace;
            o.wtd_impressions = site.revenue_stats && site.revenue_stats.total_impressions ? site.revenue_stats.total_impressions : 0;
            o.wtd_revenue = site.revenue_stats && site.revenue_stats.total_revenue ? site.revenue_stats.total_revenue : 0;
            o.wtd_ad_requests = site.revenue_stats && site.revenue_stats.total_ad_requests ? site.revenue_stats.total_ad_requests : 0;
        }
        return o;
    });
    let headers = ['id', 'name', 'publisher_id', 'type', 'active'];
    if (globalRole === 'admin') {
        headers = headers.concat(['adunit_path', 'prediction_pace', 'wtd_impressions', 'wtd_revenue', 'wtd_ad_requests']);
    }
    jsonExport(sitesForExport, {
        headers: headers
    }, (err, csv) => {
        downloadCSV(csv, 'sites');
    });
};

const ListActions = (props) => {
    const { className, maxResults, ...rest } = props;
    const { total } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            <FilterButton />
            <CreateButton />
            <ExportButton disabled={total === 0} maxResults={10000} exporter={exporter}/>
        </TopToolbar>
    );
};

export const SiteList = ({ permissions, ...props }) => {
  globalRole = (permissions) ? permissions.role : 'publisher';
  return (
    <List {...props} filters={siteFilters} perPage={100} bulkActionButtons={false} actions={<ListActions />}>
        <Datagrid rowClick="edit">
            <TextField source="code" label="ID" />
            <TextField source="name" label="Name" />
            <TextField source="publisher_name" label="Publisher Name" />
            <DateField source="updated_at" label="Update Date" />
            <DateField source="created_at" label="Creation Date" />
            {permissions && permissions.role === 'admin' &&
                [
                <NumberField source="revenue_stats.total_impressions" label="WTD Impressions" />,
                <NumberField source="revenue_stats.total_revenue" label="WTD Revenue" options={{ style: 'currency', currency: 'USD' }} />,
                <NumberField source="revenue_stats.total_ad_requests" label="WTD Ad Requests" />
                ]
            }
            <BooleanField source="active" label="Active" />
            <AuditListStatus {...props} label="Audit"/>
            <AdstxtListStatus {...props} label="Adstxt"/>
            <FunctionField label="Viewability" render={record => record.viewability || record.site_viewability ? utils.formatDouble(record.viewability || record.site_viewability, '%', 2) : 'N/A'} />
        </Datagrid>
    </List>
  )
};

const SiteTitle = ({ record }) => {
    const inactiveButton = <Button disabled="true" label='Inactive' size="small" variant='contained' disableElevation
    startIcon={<InactiveIcon />} style={InactiveButtonStyle}></Button>
    return [<div>
        Site {record ? `"${record.name}"` : ''} {record && record.active ? '' : inactiveButton}
        {record.domain && record.domain.adstxt_results && !record.domain.adstxt_results.status ? <MissingAdstxtButton /> : ''}
        {record.domain && record.domain.audit_status==='rejected' ? <RejectedButton />: ''}
        {record.domain && record.domain.blocked ? <BlockedButton /> : ''}
    </div>]
};

const CustomToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
        <br />
        <DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
        <TextField source="updated_name" label="" style={{ padding: '10px' }} />
    </Toolbar>
);

const parentSiteRenderer = (choice) => {
    if (!choice || !choice.name) return;
    return `${choice.name}  (${choice.adunit_path})`;
};

function IFrame(props) {
    let url = props.src + "?id=" + props.record.code + "&width=" + props.width + "&height=" + props.height;
    return <iframe src={url} width="800" height="180" style={{ border: "3px dotted lightgray" }}></iframe>;

}

function showWrapperTag (target) {
    // console.log('this.props.record: ', target);
}

// this.props.record.bidder_audit_status_list = this.props.record.bidder_audit_status ? Object.keys(this.props.record.bidder_audit_status).map(id=> {return {bidder_id:id, ...this.props.record.bidder_audit_status[id]} }) : []
// export const SiteEdit = ({ permissions, type, ...props }) => (
export class SiteForm extends React.Component {
    getAdstxtCoverageRate = function (record) {
        let total = 0;
        if (record && record.adstxt_results && record.adstxt_results.bidder_results) {
            total = record.adstxt_results.bidder_results.length;
            if (total > 0) {
            const positive = record.adstxt_results.bidder_results.filter(x=> x.status).length;
            return 100 * Number(positive) / Number(total);
            }
        }
        return 0;
    }
    render (props) {
    if (this.props.record && this.props.record.domain && this.props.record.domain.adstxt_results && this.props.record.domain.adstxt_results.bidder_results) {
      this.props.record.domain.adstxt_results.bidder_results = this.props.record.domain.adstxt_results.bidder_results.filter(x => !EXCLUDED_BIDDERS_LIST.includes(x.bidder_id));
      this.props.record.domain.adstxt_results.bidder_results.sort( (x, y) => (x.bidder_name>y.bidder_name) ? 1 : -1 );
    }
    this.props.record.bidder_audit_status_list =  this.props.record.domain && this.props.record.domain.bidder_audit_status ? Object.keys(this.props.record.domain.bidder_audit_status).map(id=> {return {bidder_id:id, ...this.props.record.domain.bidder_audit_status[id]} }) : [];
    this.props.record.bidder_audit_status_list.sort( (x, y) => (x.bidder_name>y.bidder_name) ? 1 : -1 );
    this.adstxtCoverageRate = this.getAdstxtCoverageRate(this.props.record.domain);
    const type = this.props.type;
    const permissions = this.props.permissions;
    return(
    
        <TabbedForm redirect={false} toolbar={<CustomToolbar /> } {...this.props} validate={validateAdsTxtFormat} validateOnBlur={true}>
            <FormTab label="Site Settings">

                {permissions && permissions.role === 'admin' &&
                    <BooleanInput source="active" label="Active" defaultValue={true} validate={required()} style={{ width: '10%' }} />
                }

                {(permissions && permissions.role === 'publisher') &&
                    <BooleanField source="active" label="Active" defaultValue={true} validate={required()} style={{ width: '10%' }} />
                }

                {permissions && permissions.role === 'admin' &&
                    <TextField source="code" label="Site ID" validate={required()} />
                }

                {(permissions && permissions.role === 'publisher') &&
                    <TextField source="code" label="Site ID" validate={required()} />
                }

                {permissions && permissions.role === 'admin' &&
                  <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
                    <SelectInput label="Type" source="type" choices={utils.SITE_TYPES} validate={required()} />
                    <FormDataConsumer>
                      {({ formData }) => { 
                        if (formData) {
                          const adsTxtType = formData.type === "app" ? "app-ads.txt" : "ads.txt";

                          return <TextInput
                            source="adstxt_domain"
                            label={`${ adsTxtType } location`}
                            helperText={ `${ adsTxtType } location, ie: http://www.site.com/${adsTxtType}` }
                            style={{ width: '30%', marginLeft: '20px' }}
                            validate={ formData.type === "app" ? required() : undefined }
                          />
                        }
                      }}
                    </FormDataConsumer>
                  </Box>
                }

                {(permissions && permissions.role === 'publisher') && type &&
                    <TextField source="type" label="Type" style={{ width: '10%' }} />
                }

                {permissions && permissions.role === 'admin' &&
                    <TextInput source="name" editable = {false} label="Site Name" style={{ width: '400px' }} validate={required()} />
                }

                {(permissions && permissions.role === 'publisher') &&
                    <TextField source="name" label="Site Name" style={{ width: '400px' }} validate={required()} />
                }

                {permissions && permissions.role === 'admin' &&
                    <ReferenceField label="Publisher" source="publisher_id" reference="publishers">
                        <TextField source="name" />
                    </ReferenceField>
                }
                {(permissions && permissions.role === 'publisher') &&
                    <ReferenceField label="Publisher" source="publisher_id" reference="publishers">
                        <TextField source="name" />
                    </ReferenceField>
                }

                <FormDataConsumer>
                  {({ formData }) => formData && formData.publisher_id === 103 && 
                    <TextInput source="site_publisher_gam_account_id"
                      label="GAM Network ID"
                      style={{ width: 400 }}
                      helperText="Only required if Publisher is MCM Approved."
                    />
                  }
                </FormDataConsumer>

                <br></br>

                {permissions && permissions.role === 'admin' &&
                    <TextField source="adunit_path" label="Ad Unit Path" defaultValue="/64387298/" style={{ width: '400px' }} validate={required()} />
                }
                <div style={{ width: "100%" }}>
                    <hr></hr>
                </div>
                {permissions && permissions.role === 'admin'
                    && [<TextInput source="top_level_domain" label="Top level domain" helpText="Format: example.com" style={{ width: 200 }} />
                    ,<ReferenceField label="Domain" source="domain_id" reference="domains">
                         <TextField source="name" />
                       </ReferenceField>]
                }

                <br/>

                {permissions && permissions.role === 'admin' &&
                    <TextInput source="report_name" label="AdSense Report Name" style={{ width: 200 }} />
                }

                {permissions && permissions.role === 'admin' &&
                    <NumberInput source="revshare" label="Revshare" helperText="The revshare is inherited from the Publisher. 20 means 20% for NoBid and 80% for the Publisher" />
                }

                {permissions && permissions.role === 'admin' &&
                [
                    <br />
                    ,
                    <h3>Advanced</h3>
                    ,
                    <NumberInput source="hard_floor" label="Hard Floor" helperText="Any price or prediction below this value will be rejected. In US Dollars $." style={{ width: '400px' }} />
                    ,
                    <ReferenceInput source="parent_site_id" label="Parent Site For Subdomains" reference="sites"
                        basePath='sites'
                        perPage={20}
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty>
                        <AutocompleteInput label="Sites" optionText={parentSiteRenderer} optionValue="code" style={{ width: '400px' }} />
                    </ReferenceInput>
                    ,
                    <SelectInput label="Viewability" source="viewability" allowEmpty emptyText="- None -"
						choices={[
								{ id: 1, name:   'At 1%' },
								{ id: 10, name:  'At 10%' },
								{ id: 20, name:  'At 20%' },
								{ id: 30, name:  'At 30%' },
								{ id: 40, name:  'At 40%' },
								{ id: 50, name:  'At 50%' },
								{ id: 60, name:  'At 60%' },
								{ id: 70, name:  'At 70%' },
								{ id: 80, name:  'At 80%' },
								{ id: 90, name:  'At 90%'},
								{ id: 100, name: 'At 100%'}
						]}
					/>
                ]
                }

                {permissions && permissions.role === 'admin' &&
                <SelectInput source='fpid_enabled' label='First Party ID' helperText='Allow First Party ID technology'
                        defaultValue='none'
                        choices={[
                            { id: 'none', name: 'Disabled' },
                            { id: 'all', name: 'Enable on All browsers' },
                            { id: 'safari', name: 'Enable on Safari browser only' }
                        ]} style={{width: '20%'}} />
                }
            </FormTab>

            <FormTab label="App Settings">
                {permissions && permissions.role === 'admin' &&
                [
                <br/>,<br/>,
                <ArrayInput source="store_urls" label="Store URLs">
                    <SimpleFormIterator>
                        <SelectInput source="store" choices={[
                            {id: 'apple', name: 'Apple App Store'},
                            {id: 'roku', name: 'Roku App Store'},
                            {id: 'google', name: 'Google Play App Store'},
                            {id: 'samsung', name: 'Samsung App Store'},
                            {id: 'amazon', name: 'Amazon Prime'}
                        ]}
                        label="Store" helpText="Store name" />
                        <TextInput source="url" label="URL" helpText="URL in the App Store" style={{ width: '40%' }} />
                        <FormDataConsumer>
                        {({ formData, scopedFormData }) => scopedFormData && scopedFormData.url && 
                        <Link href={scopedFormData.url} target="_blank">{scopedFormData.url}</Link>
                        }
                        </FormDataConsumer>
                        <br/><br/><br/>
                    </SimpleFormIterator>
                </ArrayInput>
                ]
                }
                {permissions && permissions.role === 'admin' && 
                    [
                        <ArrayField source="store_urls">
                        <Datagrid>
                            <TextField source="store" />
                            <UrlField source="url" />
                        </Datagrid>
                    </ArrayField>
                    ]
                }
                <br/><br/>
            </FormTab>

            { this.props.record?.type === 'site' && ['admin', 'publisher'].includes(permissions?.role) &&
                <FormTab label="Prebid Wrapper">
                    <div style={{width: '80%', margin: '10px', fontSize: 'small'}}>
                    The NoBid Prebid Wrapper is an advanced Prebid.js Wrapper that allows Ad Operation teams to manage their Prebid.js wrapper without any coding.<br/>
                    Combined with the NoBid Analytics Adapter and our Auction Optimizer technology, the NoBid Prebid Wrapper reduces your carbon footprint, increases your page load time and 
                    increases your inventory CPM value.
                    </div>
                    <WrapupScriptDeploy {...this.props}/>
                    <br/>
                    <SiteTabs props={props} />
                </FormTab>
            }

            {permissions && permissions.role === 'admin' &&
                <FormTab label="Bidder Settings">
                    <SyncAppnexusButton />
                    <table style={{ width: '100%', marginTop: '10px', padding: '10px', borderRadius: '9px', border: '1px white solid' }}><tr>
                        <td style={{ width: '50%', verticalAlign: 'top' }}>
                            <SelectInput style={{ width: '350px' }} source="default_bidder_id" 
                            label="Default Prediction Bidder" 
                            choices={utils.BIDDERS_PREDICTORS} />
                            <br />
                            <NumberInput source="default_bid_price" step={0.1} precision={2}
                                style={{ width: '350px' }}
                                label="Default Bid Price"
                                helperText="This is the price used when there is no prediction in the system. Current default bid price is $0.01." />
                        </td>
                        <td style={{ verticalAlign: 'top' }}>
                            <SelectInput label="Prediction Pace" source="prediction_throttle_pace"
                                style={{ width: '350px' }}
                                helperText="10% means that predictions are only used 10% of the time for this sites. Use this for new sites until the predictions stabilize."
                                choices={utils.PACES} />
                            {/* <br />
                            <SelectInput label="Prediction Strategy" source="prediction_strategy" allowEmpty emptyText="- None -"
                                style={{ width: '350px' }}
                                helperText="Standar: bid price is the combination of Tag and AdX DA, Conservative the bid price is only the Tag price."
                                choices={[
                                    { id: "STANDARD", name: 'Standard' },
                                    { id: "CONSERVATIVE", name: 'Conservative' }
                                ]} /> */}

                            {/* <br />
                            {permissions === 'admin' &&
                                <SelectInput label="Shadow Prediction Bidder" source="shadow_prediction_bidder_id" allowEmpty emptyText="- None -"
                                    style={{ width: '350px' }}
                                    helperText="Predictions for the Shadow Bidder are used instead of the Bidder settings prediction bidder. FOR MIGRATION ONLY."
                                    choices={[
                                        { id: 307, name: 'Google AdExchange Tag (307)' }
                                    ]} />
                            } */}
                        </td>
                    </tr></table>

                    <table style={{ width: '100%', marginTop: '10px', padding: '10px', borderRadius: '9px', border: '1px white solid' }}>
                    <tr>
                    <td style={{ width: '50%', verticalAlign: 'top' }}>
                    <BooleanInput source="fast_lane_enabled" style={{ width: '30%' }} label="Enable Fast Lane" helperText="Fast lane enables for faster ad rendering by skipping GAM/DFP. Use this flag with caution b/c this will eliminate Google Dynamic Allocation revenue. Only use for sites that are not approved on Google." />

                    {permissions && permissions.role === 'admin' &&
                        [
                        <NumberInput source="rtb_net_revenue_adjustment" label="RTB Net Revenue Adjustment"
                            helperText="This adjustment will be applied in reporting for the net RTB revenue. A value of 1.1 means that the net revenue will be increased by 10% for RTB bidders ONLY."
                            style={{ width: '30%' }} />,
                        <ReferenceArrayInput source="rtb_net_revenue_adjustment_bidders"
                            reference="bidders"
                            basePath="bidders"
                            perPage={15}
                            sort={{ field: 'name', order: 'ASC' }}
                            filter={{bidder_type: 'RTB'}}
                            filterToQuery={searchText => ({ search_name: searchText })}
                            allowEmpty 
                            style={{ width: '100%' }}>
                            <AutocompleteArrayInput label="RTB Net Revenue Adjustment Bidders"
                                optionText={choice => choice && choice.name ? `${choice.name} (${choice.code})` : ''}
                                optionValue="code" style={{ width: '100%' }} />
                        </ReferenceArrayInput>
                        ]
			        }
                    </td>
                    <td style={{ verticalAlign: 'top' }}>
                    <h4>Bid Priority</h4>
                    <table>
                    <tr>
                    <td style={{textAlign: 'right', paddingRight: '8px', paddingBottom: '20px'}}>Prediction</td>
                    <td><SelectInput source="bid_priority_config.PREDICTOR" label="Prediction Priority" 
                    initialValue="1"
                    choices={[
                        {id:3, name: 'HIGH (3)'},
                        {id:2, name: 'MEDIUM (2)'},
                        {id:1, name: 'LOW (1)'}
                    ]}/></td>
                    </tr>
                    <tr>
                    <td style={{textAlign: 'right', paddingRight: '8px', paddingBottom: '20px'}}>RTB</td>
                    <td><SelectInput source="bid_priority_config.RTB" label="RTB Priority" 
                    initialValue="1"
                    choices={[
                        {id:3, name: 'HIGH (3)'},
                        {id:2, name: 'MEDIUM (2)'},
                        {id:1, name: 'LOW (1)'}
                    ]}/></td>
                    </tr>
                    <tr>
                    <td style={{textAlign: 'right', paddingRight: '8px', paddingBottom: '20px'}}>Direct</td>
                    <td><SelectInput source="bid_priority_config.DIRECT" label="Direct Priority" 
                    initialValue="1"
                    choices={[
                        {id:3, name: 'HIGH (3)'},
                        {id:2, name: 'MEDIUM (2)'},
                        {id:1, name: 'LOW (1)'}
                    ]}/></td>
                    </tr>
                    </table>
                    </td></tr>
                    </table>

                    <hr style={{ width: '100%' }} />
                    <ArrayInput source="bidder_config">
                        <SimpleFormIterator>
                            <SelectInput style={{ width: '350px' }} source="bidder_id" 
                            label="Bidder" 
                            choices={utils.BIDDERS_SELECTABLE} />
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
                                    && utils.BIDDERS_PREDICTION_DISABLABLE.includes(scopedFormData.bidder_id)
                                    && <BooleanInput {...props} label="Disable Prediction" source={getSource('prediction_disabled')} helperText="Set this flag when we still have reports related to this site but we don't want to have bids at the moment." {...rest} />
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id == '309' 
                                    && [<span style={{ fontSize: 'small' }}>Zone ID</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} label="Seat ID" source={getSource('seat_id')} {...rest} />]
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id == '401' &&
                                    <TextInput {...props} style={{ width: '350px' }} label="Seat ID" source={getSource('seat_id')} {...rest} />
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id == '310' 
                                && [<span style={{ fontSize: 'small' }}>Size Tag IDs</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} multiline label="Size Tag IDs" source={getSource('size_tags')} helperText="Format: 300x25:ID\n728x90:ID" {...rest} />]
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id == '314' &&
                                    <TextInput {...props} style={{ width: '350px' }} multiline label="Size Tags ID" source={getSource('size_tags')} helperText="Format: 300x25:ID\n728x90:ID" {...rest} />
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
                                     && (utils.BIDDERS_REQUIRE_SITE_ID.includes(scopedFormData.bidder_id)) &&
                                    [<span style={{ fontSize: 'small' }}>{utils.BIDDERS_REQUIRE_SITE_ID_LABEL[scopedFormData.bidder_id] || 'Site ID'}</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} label="Site ID" source={getSource('site_id')} {...rest} />]
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
                                    && ([379].includes(scopedFormData.bidder_id))
                                    && [<span style={{ fontSize: 'small' }}>DM Publisher ID</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} label="Publisher ID" source={getSource('publisher_id')} {...rest} />]
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id == '101' &&
                                    <span>
                                        <TextInput {...props} style={{ width: '350px' }} multiline label="Size Tags" source={getSource('size_tags')} helperText="Format: 300x25:ID\n728x90:ID" {...rest} />
                                        <BooleanInput {...props} label="Disable Prediction" source={getSource('prediction_disabled')} helperText="Set this flag when we still have reports related to this site but we don't want to have bids at the moment." {...rest} />
                                    </span>
                                }
                            </FormDataConsumer>
                        </SimpleFormIterator>
                    </ArrayInput>
                </FormTab>
            }

            {permissions && ['admin', 'publisher'].includes(permissions.role) &&
                <FormTab label="Ads.txt">
                    <div style={{fontSize: 'normal', marginBottom: '10px'}}>AdsTxt Status</div>
                    <FormDataConsumer>
                    {({ formData }) => formData && formData.domain && formData.domain.adstxt_results && !formData.domain.adstxt_results.status && 
                        [<MissingAdstxtButton />,<br/>,<br/>]
                    }
                    </FormDataConsumer>
                    <CrawlButton /><br/>
                    {permissions && ['admin'].includes(permissions.role) 
                    && [
                    <BooleanField source="domain.adstxt_crawl_skip" label="Disable Ads.txt Crawling" style={{ width: '250px' }} />
                    , <BooleanInput source="ignore_adstxt_results" label="Ignore Ads.txt" style={{ width: '250px' }} />
                    , <AnalyzeSiteButton parent={this}/>, <br/>
                    ]
                    }
                    {permissions && ['publisher'].includes(permissions.role) && [<br/>,<br/>,<br/>]}
                    <span>Adstxt Coverage Rate: {this.adstxtCoverageRate.toFixed(0)}%</span>
                    <ArrayField source="domain.adstxt_results.bidder_results" label="Ads.txt Status">
                        <Datagrid style={{ width: '50%' }}>
                            {permissions && ['admin'].includes(permissions.role) && 
                            <FunctionField label="Bidder" render={record => `${record.bidder_name} (${record.bidder_id})`} 
                            style={{ whiteSpace: 'nowrap' }}/>
                            }
                            {permissions && !['admin'].includes(permissions.role) && 
                            <TextField label="Bidder" source="bidder_name" style={{ whiteSpace: 'nowrap' }}/>
                            }
                            <BidderStatus label="Ads.txt Status"/>
                            <AuditStatus label="Audit Status" parent={this.props.record.domain}/>
                            {permissions && ['admin'].includes(permissions.role) && 
                            [
                            ,<NumberField label="Total Response Rate" source="total_response_rate" style={{ whiteSpace: 'nowrap', color: 'yellow' }}/>
                            ,<FunctionField label="Revenue" render={record => record.net_revenue ? <span style={{color: record.color}}>{record.net_revenue}</span> : ''} style={{ whiteSpace: 'nowrap' }}/>
                            ,<FunctionField label="Gross Revenue" render={record => record.revenue ? <span style={{color: record.color}}>{record.revenue}</span> : ''} style={{ whiteSpace: 'nowrap' }}/>
                            ,<FunctionField label="Impressions" render={record => record.impressions ? <span style={{color: record.color}}>{record.impressions}</span> : ''} style={{ whiteSpace: 'nowrap' }}/>
                            ,<FunctionField label="Bid Requests" render={record => record.bid_requests ? <span style={{color: record.color}}>{record.bid_requests}</span> : ''} style={{ whiteSpace: 'nowrap' }}/>
                            ,<FunctionField label="Bid Responses" render={record => record.bid_responses ? <span style={{color: record.color}}>{record.bid_responses}</span> : ''} style={{ whiteSpace: 'nowrap' }}/>
                            ,<FunctionField label="Response Rate" render={record => record.response_rate ? <span style={{color: record.color}}>{record.response_rate}</span> : ''} style={{ whiteSpace: 'nowrap' }}/>
                            ,<FunctionField label="RPM Bid Requests" render={record => record.rpm_bid_requests ? <span style={{color: record.color}}>{record.rpm_bid_requests}</span> : ''} style={{ whiteSpace: 'nowrap' }}/>
                            ,<FunctionField label="Win Rate" render={record => record.win_rate ? <span style={{color: record.color}}>{record.win_rate}</span> : ''} style={{ whiteSpace: 'nowrap' }}/>
                            ,<FunctionField label="Tech cost" render={record => record.tech_cost ? <span style={{color: record.color}}>{record.tech_cost}</span> : ''} style={{ whiteSpace: 'nowrap' }}/>
                            ,<FunctionField label="Net Profit" render={record => record.net_profit ? <span style={{color: record.color, fontWeight: 'bold'}}>{record.net_profit}</span> : ''} style={{ whiteSpace: 'nowrap' }}/>
                            ]
                            }
                        </Datagrid>
                    </ArrayField>
                    <TextField source="domain.last_crawl" label="Last Adxtxt Crawl Time" />
                    <AdstxtIPWhiteList />
                </FormTab>
            }

            {permissions && ['admin', 'publisher'].includes(permissions.role) &&
                <FormTab label="Audit">
                    <AuditStatusDetail label="Audit Status" {...permissions}/>
                </FormTab>
            }

            {permissions && permissions.role === 'admin' &&
                <FormTab label="Revenue Summary">
                    <FunctionField label="Viewability" render={record => record.viewability || record.site_viewability ? utils.formatDouble(record.viewability || record.site_viewability, '%', 2) : 'N/A'} />
                    <NumberField source="revenue_stats.total_impressions" label="Week To Date Impressions" />
                    <NumberField source="revenue_stats.total_revenue" label="Week To Date Revenue ($)" options={{ style: 'currency', currency: 'USD' }} />
                    <NumberField source="revenue_stats.total_ad_requests" label="Week To Date Ad Requests" />

                    <ArrayField source="revenue_stats.daily">
                        <Datagrid>
                            <CustomDateField label="Date" />
                            <NumberField source="impressions" label="Impressions" />
                            <NumberField source="revenue" label="Revenue" options={{ style: 'currency', currency: 'USD' }} />
                            <NumberField source="avg_cpm" label="CPM" options={{ style: 'currency', currency: 'USD' }} />
                            <NumberField source="ad_requests" label="Ad_Requests" />
                            <FunctionField render={record => record.fill_rate ? utils.formatDouble(record.fill_rate*100, '%') : ''} label="%Fill_Rate" />
                        </Datagrid>
                    </ArrayField>

                    <br />

                    <Card style={{ width: '100%' }} raised>
                        <CardHeader title="Revenue Last 7 Days" />
                        <CardContent>
                            <FormDataConsumer>
                                {({ formData, ...rest }) =>
                                    <RevenueChart source={formData} />
                                }
                            </FormDataConsumer>
                        </CardContent>
                    </Card>

                </FormTab>
            }

            <FormTab label="Site Info">
                <h4>IAB Categories</h4>
                <ReferenceArrayInput source="iab_categories"
                        reference="iab_categories"
                        basePath='iab_categories'
                        perPage={200}
                        sort={{ field: 'name', order: 'DESC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}>
                        <AutocompleteArrayInput label="IAB Categories" optionText="name" style={{ width: '90%' }} />
                </ReferenceArrayInput>
                <h4>Media Categories</h4>
                <SelectArrayInput source="media_categories" choices={mediaCategories} />
                <br/>
                <NumberInput source="site_info.page_views" step={1000} label="Page Views" helperText="Expected monthly page views." />
                <NumberInput source="site_info.impressions" step={1000} label="Impressions" helperText="Expected monthly impressions." />
                <BooleanInput source="site_info.refreh_ads" label="Does site refresh ads?" style={{ width: '40%' }} />
                <BooleanInput source="creative_safeframe" label="Are creatives rendered in a SafeFrame?" style={{ width: '40%' }} />

                {permissions && permissions.role === 'admin' &&
                    <SelectArrayInput label="Integration Types" source="site_info.integration_types" choices={[
                        { id: 'PREBID_ADAPTER', name: 'Prebid Adapter' },
                        { id: 'NOBID_AD_TAG', name: 'NoBid Ad Tag' },
                        { id: 'DFP_PASSBACK_TAG', name: 'Google DFP Passback Tag' },
                        { id: 'ADX_TAG', name: 'Google Ad Exchange Tag' },
                        { id: 'GOOGLE_AMP', name: 'Google AMP' }
                    ]} />
                }

                {permissions && permissions.role === 'admin' &&
                    <TextInput multiline source="site_info.notes" label="Notes" helperText="Special notes about this site." style={{ width: '40%' }} />
                }

            </FormTab>

            {(permissions && ['admin', 'publisher'].includes(permissions.role)) &&
                <FormTab label="Custom Ad Formats">
                    <h4>Combo Settings</h4>
					<div style={{border: '1px solid', width: 'fit-content', padding: '20px', borderRadius: '5px', marginBottom: '50px'}}>
                        <BooleanInput source="combo_enabled" label="Combo Desktop 300x600 (2 * 300x250) Enabled" />
                        <BooleanInput source="combo_large_enabled" label="Combo Desktop 970x250 (3 * 300x250) Enabled" />
                        <BooleanInput source="combo_mobile_enabled" label="Combo Mobile 300x250 (2 * 320x50) Enabled" />
                        <Button href="https://public.servenobid.com/partner/combo/index.html" label="Combo Demo" target="_blank" startIcon={<LinkIcon />} />
                    </div>

                    <h4>Opt-In Ad Categories</h4>
                    <SelectArrayInput label="Special Ad Categories" source="special_ad_categories" choices={specialCategories} style={{minWidth: '285px', width: 'auto', maxWidth: '650px'}}/>

                </FormTab>
            }

            <FormTab label="Ad Tags">

                <br />
                <h3 style={{ width: '100%', textAlign: 'center' }}>Prebid Configuration</h3>
                <Button style={{ width: '30%' }}
                    href="https://prebid.org/dev-docs/bidders.html#nobid"
                    label="Prebid Documentation"
                    variant="contained"
                    color="primary"
                    target="_blank"
                    startIcon={<LinkIcon />} />

                <br /><hr style={{ width: '100%' }} /><br />

                <br />
                <h3 style={{ width: '100%', textAlign: 'center' }}>NoBid Catch-All Tag</h3>
                <Button style={{ width: '30%' }}
                    href="https://docs.google.com/document/d/1FFvD_ihCcahkBh6bb0Ysr7eYuDIWPuFIgnl0TyAdV5k/edit"
                    label="NoBid Catch-All Tag Documentation"
                    variant="contained"
                    color="primary"
                    target="_blank"
                    startIcon={<LinkIcon />} />

                <br />
                <IFrame src="tag_catch_all.html" width="320" height="50" />

                <br /><hr style={{ width: '100%' }} /><br />

                <h3 style={{ width: '100%', textAlign: 'center' }}>Google AMP Tag</h3>
                <span>NoBid provides AMP integration through your current GAM/DFP AMP setup.</span>
                <ol style={{ width: '100%', lineHeight: 2 }}>

                    <li style={{ width: '100%' }}>
                        Setup NoBid GAM/DFP line items for AMP.<br />
          Add gam@nobid.io user to your GAM/DFP and contact your NoBid account representative for more details.
          </li>

                    <li>
                        Add once per page the following Sync Tag:

          <br />
                        <div style={{ width: '800px' }}><iframe src="tag_ampsync.html" width="800" height="70" style={{ border: "3px dotted lightgray" }}></iframe></div>
                    </li>

                    <li>
                        The following are the tags that you need to implement on page:
          </li>
                </ol>

                <h4>300x250</h4>
                <IFrame src="tag_amp.html" width="300" height="250" />
                <br />

                <h4>320x50</h4>
                <IFrame src="tag_amp.html" width="320" height="50" />


                <br /><hr style={{ width: '100%' }} /><br />
                <h3 style={{ width: '100%', textAlign: 'center' }}>Ad Server Tag (GAM/DFP, ...)</h3>
                <h4>Display/Banner Tag</h4>
                <span style={{ fontSize: 'smaller' }}>For RON tags use your Publisher ID as a siteId.</span><br />
                <IFrame src="tag_passback.html" width="320" height="50" />

                <br />
                <h4>Video Tag</h4>

                <h5>Desktop</h5>
                <span style={{ fontSize: 'smaller' }}>For RON tags use your Publisher ID as a siteId.</span><br />
                <IFrame src="tag_video.html" width="640" height="480"></IFrame>

                <h5>Mobile</h5>
                <span style={{ fontSize: 'smaller' }}>For RON tags use your Publisher ID as a siteId.</span><br />
                <IFrame src="tag_video.html" width="400" height="300"></IFrame>

                <br /><hr style={{ width: '100%' }} /><br />
                <h3 style={{ width: '100%', textAlign: 'center' }}>NobBid Publisher Tag</h3>
                <span>
                    This tag is a custom NoBid header bidder wrapper to be used only if you are not on Prebid header bidder wrapper.
        <br />
                    <ol style={{ width: '100%', lineHeight: 2 }}>

                        <li>First step is to setup NoBid GAM/DFP line items.
        <br />Add gam@nobid.io user to your GAM/DFP and contact your NoBid account representative for more details.
        </li>

                        <li>
                            The following are the tags that you need to implement on page:
        </li>

                    </ol>

                </span>
                <IFrame src="tag_nobid.html"></IFrame>

            </FormTab>

        </TabbedForm>
    );
    }
}

const validJSON = input => { if (input) { try { JSON.parse(input) } catch (e){ return "Invalid JSON: " + e} }};

const getAdSizeChoices = (type) => {
    let c = AD_SIZES.sort((a, b) => a[0] - b[0] || a[1] - b[1]).map(x=>({id: JSON.stringify(x), name: `${x[0]}x${x[1]}`}));
    return c.filter(x=> Number(x.name.split('x')[0]) < SCREEN_SIZES_WIDTH_RANGE.find(x => x.name === type).maxSize);
}

export const SiteCreate = (props) => {
    const [adPaths, setAdPaths] = useState();

    function getAdPaths(id) {
        console.log("Publisher id: " + id);
        dataProvider.getOne('publishers', { id: id }).then(publisher => {
            // console.log(publisher.data['ad_unit_paths'])
            setAdPaths(publisher.data['ad_unit_paths']);
        })
    }

    const AdParentInput = props => {
        const form = useForm();
        const {values} = useFormState();

        if (adPaths && adPaths.length > 1) {
            if (values.ad_unit_parent_id && !adPaths.map(x=>x.id).includes(values.ad_unit_parent_id)) {
                form.change('ad_unit_parent_id', null);
            }
            return (
                <SelectInput
                    choices={adPaths}
                    {...props} source="ad_unit_parent_id" label="Ad Unit Parent" validate={required()}
                />
            );
        }
        if (adPaths && adPaths.length < 2) form.change('ad_unit_parent_id', adPaths[0].id);
        return null
    };

    return (
        <Create title="Create Site" {...props}>
            <TabbedForm validateOnBlur={true} >
                <FormTab label="Site Settings" validate={validateAdsTxtFormat} >
                    <BooleanInput source="active" label="Active" defaultValue={true} validate={required()} style={{ width: '10%' }} />
                    <TextInput source="name" label="Site Name" style={{ width: '400px' }} validate={required()} />
                    <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
                    <SelectInput label="Type" source="type" choices={utils.SITE_TYPES} validate={required()} />
                    <FormDataConsumer>
                        {({ formData }) => { 
                        if (formData) {
                            const adsTxtType = formData.type === "app" ? "app-ads.txt" : "ads.txt";

                            return (
                                <TextInput source="adstxt_domain" label={`${ adsTxtType } location`}
                                    style={{ width: '450px', marginLeft: '20px' }}
                                    validate={ formData.type === "app" ? required() : undefined }
                                    helperText={`${ adsTxtType } location, ie: http://www.site.com/${adsTxtType}`}
                                />
                            )
                        }
                        }}
                    </FormDataConsumer>
                    </Box>
                    <ReferenceInput source="publisher_id" label="Publisher" reference="publishers" onChange={(e) => { getAdPaths(e) }}
                        basePath='publishers'
                        perPage={10}
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        validate={required()}
                    >
                        <AutocompleteInput label="Publishers" optionText="name" optionValue="code" style={{ width: '90%' }} />
                    </ReferenceInput>
                    <AdParentInput/>
                    <FormDataConsumer>
                    {({ formData }) => formData && formData.publisher_id === 103 && 
                        <TextInput source="site_publisher_gam_account_id"
                        label="GAM Network ID"
                        style={{ width: 400 }}
                        helperText="Only required if Publisher is MCM Approved."
                        />
                    }
                    </FormDataConsumer>
                    <br></br>

                    <div style={{ width: "100%" }}>
                        <hr></hr>
                    </div>
                    <TextInput source="top_level_domain" label="Top level domain" helpText="Format: example.com" style={{ width: 200 }} />

                    <TextInput source="report_name" label="AdSense Report Name" style={{ width: 200 }} />
                    <NumberInput source="revshare" label="Revshare" helperText="30 means 30% for NoBid and 70% for the Publisher" />

                    <br />
                    <h3>Advanced</h3>

                    <NumberInput source="hard_floor" label="Hard Floor" helperText="Any price or prediction below this value will be rejected. In US Dollars $." style={{ width: '400px' }} />

                    <ReferenceInput source="parent_site_id" label="Parent Site For Subdomains" reference="sites"
                        basePath='sites'
                        perPage={20}
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty>
                        <AutocompleteInput label="Sites" optionText={parentSiteRenderer} optionValue="code" style={{ width: '400px' }} />
                    </ReferenceInput>

                    <SelectInput label="Viewability" source="viewability" allowEmpty emptyText="- None -"
                        choices={[
                                { id: 1, name:   'At 1%' },
                                { id: 10, name:  'At 10%' },
                                { id: 20, name:  'At 20%' },
                                { id: 30, name:  'At 30%' },
                                { id: 40, name:  'At 40%' },
                                { id: 50, name:  'At 50%' },
                                { id: 60, name:  'At 60%' },
                                { id: 70, name:  'At 70%' },
                                { id: 80, name:  'At 80%' },
                                { id: 90, name:  'At 90%'},
                                { id: 100, name: 'At 100%'}
                        ]}
                    />

                </FormTab>

                <FormTab label="App Settings">
                    <br/><br/>
                    <ArrayInput source="store_urls" label="Store URLs">
                        <SimpleFormIterator>
                            <SelectInput source="store" choices={[
                                {id: 'apple', name: 'Apple App Store'},
                                {id: 'roku', name: 'Roku App Store'},
                                {id: 'google', name: 'Google Play App Store'},
                                {id: 'samsung', name: 'Samsung App Store'},
                                {id: 'amazon', name: 'Amazon Prime'}
                            ]}
                            label="Store" helpText="Store name" />
                            <TextInput source="url" label="URL" helpText="URL in the App Store" style={{ width: '40%' }} />
                            <UrlField source="url" label="Store URL" helpText="" style={{ width: '40%' }} target="_blank"/>
                        </SimpleFormIterator>
                    </ArrayInput>
                </FormTab>

                <FormTab label="Bidder Settings">
                    <SyncAppnexusButton />
                    <table style={{ width: '100%', marginTop: '10px', padding: '10px', borderRadius: '9px', border: '1px white solid' }}><tr>
                        <td style={{ width: '50%', verticalAlign: 'top' }}>
                            <SelectInput style={{ width: '350px' }} source="default_bidder_id" 
                            label="Default Prediction Bidder" 
                            choices={utils.BIDDERS_PREDICTORS} />
                            <br />
                            <NumberInput source="default_bid_price" step={0.1} precision={2}
                                style={{ width: '50%' }}
                                label="Default Bid Price"
                                helperText="This is the price used when there is no prediction in the system. Current default bid price is $0.01." />
                        </td>
                        <td style={{ verticalAlign: 'top' }}>
                            <SelectInput label="Prediction Pace" source="prediction_throttle_pace"
                                style={{ width: '50%' }}
                                helperText="10% means that predictions are only used 10% of the time for this sites. Use this for new sites until the predictions stabilize."
                                choices={utils.PACES} />
                            {/* <br />
                            <SelectInput label="Prediction Strategy" source="prediction_strategy" allowEmpty emptyText="- None -"
                                style={{ width: '50%' }}
                                helperText="Standar: bid price is the combination of Tag and AdX DA, Conservative the bid price is only the Tag price."
                                choices={[
                                    { id: "STANDARD", name: 'Standard' },
                                    { id: "CONSERVATIVE", name: 'Conservative' }
                                ]} /> */}

                            {/* <br />
                            <SelectInput label="Shadow Prediction Bidder" source="shadow_prediction_bidder_id" allowEmpty emptyText="- None -"
                                style={{ width: '50%' }}
                                helperText="Predictions for the Shadow Bidder are used instead of the Bidder settings prediction bidder. FOR MIGRATION ONLY."
                                choices={[
                                    { id: 307, name: 'Google AdExchange Tag (307)' }
                                ]} /> */}
                        </td>
                    </tr></table>
                    <ArrayInput source="bidder_config">
                        <SimpleFormIterator>
                            <SelectInput style={{ width: '350px' }} source="bidder_id" label="Bidder" choices={utils.BIDDERS_SELECTABLE} />
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
                                    && utils.BIDDERS_PREDICTION_DISABLABLE.includes(scopedFormData.bidder_id)
                                    && <BooleanInput {...props} label="Disable Prediction" source={getSource('prediction_disabled')} helperText="Set this flag when we still have reports related to this site but we don't want to have bids at the moment." {...rest} />
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id == '309' 
                                && [<span style={{ fontSize: 'small' }}>Zone ID</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} label="Seat ID" source={getSource('seat_id')} {...rest} />]
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id == '401' &&
                                    <TextInput {...props} style={{ width: '350px' }} label="Seat ID" source={getSource('seat_id')} {...rest} />
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id == '310' 
                                && [<span style={{ fontSize: 'small' }}>Size Tag IDs</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} multiline label="Size Tag IDs" source={getSource('size_tags')} helperText="Format: 300x25:ID\n728x90:ID" {...rest} />]
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id == '314' &&
                                    <TextInput {...props} style={{ width: '350px' }} multiline label="Size Tags ID" source={getSource('size_tags')} helperText="Format: 300x25:ID\n728x90:ID" {...rest} />
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
                                    && (utils.BIDDERS_REQUIRE_SITE_ID.includes(scopedFormData.bidder_id))
                                    && [<span style={{ fontSize: 'small' }}>{utils.BIDDERS_REQUIRE_SITE_ID_LABEL[scopedFormData.bidder_id] || 'Site ID'}</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} label="Site ID" source={getSource('site_id')} {...rest} />]
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
                                    && ([379].includes(scopedFormData.bidder_id))
                                    && [<span style={{ fontSize: 'small' }}>DM Publisher ID</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} label="Publisher ID" source={getSource('publisher_id')} {...rest} />]
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id == '101' &&
                                    <span>
                                        <TextInput {...props} style={{ width: '350px' }} multiline label="Size Tags" source={getSource('size_tags')} helperText="Format: 300x25:ID\n728x90:ID" {...rest} />
                                        <BooleanInput {...props} label="Disable Prediction" source={getSource('prediction_disabled')} helperText="Set this flag when we still have reports related to this site but we don't want to have bids at the moment." {...rest} />
                                    </span>
                                }
                            </FormDataConsumer>
                        </SimpleFormIterator>
                    </ArrayInput>
                </FormTab>

                <FormTab label="Site Info">
                    <h4>IAB Categories</h4>
                    <ReferenceArrayInput source="iab_categories"
                        reference="iab_categories"
                        basePath='iab_categories'
                        perPage={200}
                        sort={{ field: 'name', order: 'DESC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}>
                        <AutocompleteArrayInput label="IAB Categories" optionText="name" style={{ width: '90%' }} />
                    </ReferenceArrayInput>
                    <br/>
                    <NumberInput source="site_info.page_views" step={1000} label="Page Views" helperText="Expected monthly page views." />
                    <NumberInput source="site_info.impressions" step={1000} label="Impressions" helperText="Expected monthly impressions." />
                    <BooleanInput source="site_info.refreh_ads" label="Does site refresh ads?" style={{ width: '40%' }} />
                    <BooleanInput source="creative_safeframe" label="Are creatives rendered in a SafeFrame?" style={{ width: '40%' }} />
                    <SelectArrayInput label="Integration Types" source="site_info.integration_types" choices={[
                        { id: 'PREBID_ADAPTER', name: 'Prebid Adapter' },
                        { id: 'NOBID_AD_TAG', name: 'NoBid Ad Tag' },
                        { id: 'DFP_PASSBACK_TAG', name: 'Google DFP Passback Tag' },
                        { id: 'ADX_TAG', name: 'Google Ad Exchange Tag' },
                        { id: 'GOOGLE_AMP', name: 'Google AMP' }
                    ]} />
                    <TextInput multiline source="site_info.notes" label="Notes" helperText="Special notes about this site." style={{ width: '40%' }} />
                </FormTab>

                <FormTab label="Custom Ad Format">
                    <h4>Combo Settings</h4>
					<div style={{border: '1px solid', width: 'fit-content', padding: '20px', borderRadius: '5px', marginBottom: '50px'}}>
                        <BooleanInput source="combo_enabled" label="Combo Desktop 300x600 (2 * 300x250) Enabled" />
                        <BooleanInput source="combo_large_enabled" label="Combo Desktop 970x250 (3 * 300x250) Enabled" />
                        <BooleanInput source="combo_mobile_enabled" label="Combo Mobile 300x250 (2 * 320x50) Enabled" />
                        <Button href="https://public.servenobid.com/partner/combo/index.html" label="Combo Demo" target="_blank" startIcon={<LinkIcon />} />
                    </div>

                    <h4>Opt-In Ad Categories</h4>
                    <SelectArrayInput label="Special Ad Categories" source="special_ad_categories" choices={specialCategories} style={{minWidth: '285px', width: 'auto', maxWidth: '650px'}}/>

                </FormTab>
            </TabbedForm>

        </Create >
    );
}
export const SiteEdit = ({ permissions, ...props }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const onSuccess = ({data}) => {
    notify(`Changes to site were saved.`);
    refresh();
  }
  return (
    <Edit title={<SiteTitle />} mutationMode="pessimistic" onSuccess={onSuccess} {...props}>
      <SiteForm formType="edit" permissions={permissions} {...props}/>
    </Edit>
  )
}